





























































import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'HistoryIntroEv',
  // props: {
  // },
  components: {},
  setup: () => {
    return {};
  }
});
